import { PASTEL_PURPLE, VIVID_PURPLE } from '../../styles/colors';
import React from 'react';
import { Step, StepBarContainer } from './StepBar.styles';

// Component props interface
export interface StepBarProps {
  /** Total number of steps */
  steps: number;
  /** Current active step (0-based for no steps completed, otherwise 1-based) */
  currentStep: number;
  /** Color for completed steps */
  completedColor?: string;
  /** Color for upcoming steps */
  upcomingColor?: string;
  /** Optional className for additional styling */
  className?: string;
  /** Optional style for additional styling */
  style?: React.CSSProperties;
}

/**
 * StepBar Component - Displays a horizontal progress indicator for multi-step processes
 * @param currentStep - Can be 0 (no steps completed) or 1-based for completed steps
 */
const StepBar: React.FC<StepBarProps> = ({
  steps = 3,
  currentStep = 0,
  completedColor = VIVID_PURPLE,
  upcomingColor = PASTEL_PURPLE,
  className,
  style
}) => {
  return (
    <StepBarContainer className={className} style={style}>
      {Array.from({ length: steps }, (_, index) => {
        const stepNumber = index + 1;
        const completed = currentStep > 0 && stepNumber <= currentStep;

        return (
          <Step
            key={index}
            $completed={completed}
            style={{
              backgroundColor: completed
                ? completedColor
                : upcomingColor
            }}
          />
        );
      })}
    </StepBarContainer>
  );
};

export default StepBar;
